var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7201 18.2505C17.9061 18.2505 17.2462 17.5906 17.2462 16.7766V8.19393C17.2462 5.30127 14.8928 2.94783 12.0001 2.94783C9.10743 2.94783 6.75398 5.30121 6.75398 8.19393V13.1858C6.75398 13.9998 6.09409 14.6597 5.28007 14.6597C4.46604 14.6597 3.80615 13.9998 3.80615 13.1858V8.19393C3.80615 3.67576 7.48191 0 12.0001 0C16.5183 0 20.194 3.67576 20.194 8.19393V16.7766C20.194 17.5906 19.5341 18.2505 18.7201 18.2505Z",
    fill: "#B1B4B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9679 27.1759H3.03205C1.3575 27.1759 0 25.8184 0 24.1438V13.7742C0 12.0997 1.3575 10.7422 3.03205 10.7422H20.9679C22.6425 10.7422 24 12.0997 24 13.7742V24.1438C24 25.8184 22.6425 27.1759 20.9679 27.1759Z",
    fill: "#FFB636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.631 24.7326H2.47909C2.00064 24.7326 1.61279 24.3448 1.61279 23.8663V14.0523C1.61279 13.5739 2.00064 13.186 2.47909 13.186H2.631C3.10945 13.186 3.4973 13.5739 3.4973 14.0523V23.8663C3.4973 24.3448 3.10945 24.7326 2.631 24.7326Z",
    fill: "#FFD469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "static/media/Lock icon.0c91f782392b1688d900cdb80badfa94.svg";
export { ForwardRef as ReactComponent };